<template>
    <div> 
        <div class="progress-bar-container replay">   
            <div class="progress" :style="'width:'+ formatPercent(percentComplete) + '; left:' + (percentComplete>0? '0%':'-1%')"></div>
            <div class="progress-bar-border replay"></div> 
            <a v-for="(item,itemIndex) in replayItems" :key="index"  
            :class="itemIndex==(replayItems.length-1)? '' : 'section'" 
            :style="'width:' + formatPercent(percentComplete)" :title="currentItem ? currentItem?.text : '' ">&nbsp;</a> 
 
        </div>
    </div>
</template>
<script lang="ts">
import { Options, Prop, Vue as VueBase, Watch } from 'vue-property-decorator';   
import { ReplayItem as ReplayItem } from './CardData';

export default class LessonProgressBar extends VueBase {
   
   @Prop()
   public replayItems!: ReplayItem[];

   @Prop({default:0})
   public index!: number;

   public get percentComplete()
   {
        const pct = (this.index+1)/this.replayItems.length;
        return  pct;
   } 

   public get currentItem(): any
   {
    return this.replayItems[this.index];
   }
 
    public formatPercent(value: number): string {
        const percentString = `${(value * 100)}%`;
        return percentString;
    }
 
    
}
</script>

<style lang="scss" scoped>
    @import '@/theme/_helpers.scss';
   
 

</style>